import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-blue-900 text-slate-300" data-id="element-95" data-mp="3geze367ujv27">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-96" data-mp="3ggu1cr6lbz9g" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-97" data-mp="32onkt3zizq9h">
        <p className="silver-text text-lg font-extrabold uppercase tracking-tight" data-id="element-98" data-mp="36pfsvtwnvp46">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-99" data-mp="3uf0nja26gata">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-slate-300/20 pt-6 text-xs" data-id="element-100" data-mp="38qvoyiyxrr6">
          © 2026 Megapack Energía Nuclear Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}